<template>
	<div class="ModuleLayout">
		<el-scrollbar ref="ScrollbarRef" @scroll="HandleScroll">
			<el-container>
				<el-header>
					<ComponentsTop ref="ComponentsTop"/>
				</el-header>
				<el-main>
					<router-view v-slot="{ Component }">
						<transition>
							<component :is="Component" :IsScrollBottom="IsScrollBottom" @IsScrollBottomInit="IsScrollBottomInit" @ScrollTop="ScrollTop"  @onLogin="ExternalLoginShow"/>
						</transition>
					</router-view>
				</el-main>
				<el-footer>
					<ComponentsBottom/>
				</el-footer>
			</el-container>
		</el-scrollbar>
	</div>
	<div class="ModuleBoxTopArrow" v-if="ShowTopArrow" @click="ScrollTop"></div>
</template>

<style lang="scss" scoped>
	@import "./index.scss";
</style>
<script>
  import index from "./index-Js";
  export default index;
</script>
